<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">单页设置</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:10px">
            <el-form-item label="分类">
                <el-select v-model="categorys" placeholder="请选择">
                    <el-option label="热点" value="0"></el-option>
                    <el-option label="动态" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="types" placeholder="请选择">
                    <el-option label="帖子" value="2"></el-option>
                    <el-option label="视频" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="发布时间">
                <el-date-picker
                    v-model="fwtime"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="发表用户昵称">
                <el-input v-model="nickname" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item label="发表用户手机号">
                <el-input v-model="phone" placeholder="请输入内容"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" highlight-current-row border  style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="content" label="评论内容" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="integral" label="内容标题" >
                <template slot-scope="scope">{{scope.row.hdArticle.title}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="integral" label="发表用户昵称" >
                <template slot-scope="scope">{{scope.row.auser.nickname}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="integral" label="发表用户手机号" >
                <template slot-scope="scope">{{scope.row.auser.phone}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="createdate" label="发表时间" >
                <!-- <template slot-scope="scope">{{scope.row.otherData}}</template> -->
            </el-table-column>
            <el-table-column align="center" label="操作" >
                <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="commentdelClick(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="备注">
                    <el-input el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入备注"></el-input>
                </el-form-item>
                <el-form-item label="标识" >
                    <el-input el-input size="small" :disabled="editFlag" v-model="editForm.key" auto-complete="off" placeholder="请输入标识"></el-input>
                </el-form-item>
            </el-form>
            <quill-editor
                :content="content"
                :options="editorOption"
                @change="onEditorChange($event)"
            />
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Pagination from '../../components/Pagination'
import { commentSelect , commentDel} from '../../api/userMG'
export default {
    data () {
        return {
            categorys:'',
            nickname:"",
            phone:'',
            types:'',
            fwtime:[],
            loading:false,
            rules:{},
            editFlag:false,
            editForm:{
                remark:'',
            },
            editFormVisible:false,
            content: '<h2>I</h2><p>这是射，么就卡奇我觉额定</p><p>啊索拉卡到家啊了肯定</p><p>接口</p>',
            editorOption: {
            // Some Quill options...
            },
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                nickName: '',
            },
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            }
        }
    },
    components: {
        quillEditor,
        Pagination
    },
    created(){
        this.getdata()
    },
    methods: {
        commentdelClick(id){
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                commentDel({id:id}).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addClick(){
            this.editFlag = false
            this.editFormVisible = true
            this.editForm.remark = ''
            this.content = ''
        },  
        submitForm(){
            if(this.editForm.remark == ''){
                this.$message({
                  type: 'error',
                  message: '备注不能为空'
                })
            }else{
                if(this.editFlag == true){
                    updateConfig({
                        id:this.editForm.id,
                        remark:this.editForm.remark,
                        value:this.content
                    }).then(res=>{
                        this.editFormVisible = false
                        this.getdata()
                        this.$message({
                            type: 'success',
                            message: '修改成功'
                        })
                    })
                }else {
                    if(this.editForm.key == ''){
                        this.$message({
                            type: 'error',
                            message: '标识不能为空'
                        })
                    }else{
                        createConfig({
                            remark:this.editForm.remark,
                            value:this.content,
                            key:this.editForm.key,
                            type:2
                        }).then(res=>{
                            this.editFormVisible = false
                            this.getdata()
                            this.$message({
                                type: 'success',
                                message: '新增成功'
                            })
                        })
                    }
                }
            }
        },  

        onEditorChange({ quill, html, text }) {
            this.content = html
        },
        handleEdit(row){
            console.log(row)
            this.editFlag = true
            this.editForm.remark = row.remark
            this.editForm.key = row.cKey
            this.editForm.id = row.id
            this.content = row.cValue
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        search(){
            this.formInline.page = 1
            this.pageparm.currentPage = 1
            this.getdata(this.formInline)
        },
        getdata(){
            commentSelect({
                page:this.formInline.page,
                size:this.formInline.limit,
                categorys:this.categorys == ''?'':(this.categorys == 0?this.categorys:[1 , 2]),
                types:this.types == ''?null:[`${this.types}`],
                fwtime:this.fwtime,
                nickname:this.nickname == ''?null:this.nickname,
                phone:this.phone == ''?null:this.phone,
            }).then(res=>{
                this.listData = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/socialize/CommentManagement.vue